export const getUserAgent = () => {
    const windowNavigator = window.navigator;
    const standalone = windowNavigator?.standalone;
    const userAgent = windowNavigator?.userAgent?.toLowerCase();
    const safari = /safari/.test(userAgent);
    const ios = /iphone|ipod|ipad/.test(userAgent);
    if (ios) {
        if (!standalone && safari) {
            return 'Safari';
        }
        else if (!standalone && !safari) {
            return 'iOS webview';
        }
    }
    else if (userAgent.includes('wv')) {
        return 'Android webview';
    }
    else {
        return 'Chrome';
    }
    return '';
};
//# sourceMappingURL=getUserAgent.js.map